import { render, staticRenderFns } from "./PauseOverlay.vue?vue&type=template&id=00503f84&scoped=true&"
import script from "./PauseOverlay.vue?vue&type=script&lang=js&"
export * from "./PauseOverlay.vue?vue&type=script&lang=js&"
import style0 from "./PauseOverlay.vue?vue&type=style&index=0&id=00503f84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00503f84",
  null
  
)

export default component.exports